module.exports = __webpack_public_path__ + "static/media/desktopFree.a0787785.png";